import { createFileRoute } from "@tanstack/react-router";
import ListStartPage from "@/site/pages/list-start";
import { isListKind, type ListKind } from "@/site/components/lists/list-data";

// Start a shared birthday list (PRD 16 §6.1). Members only, full session (D4) — the root
// guard sends anyone signed out (or on a soft email-link session) to /login?next=.
interface ListStartSearch {
  /** Pre-pick a kind ("Start a list for another group" chips on the list page). */
  kind?: ListKind;
}

export const Route = createFileRoute("/lists/new")({
  validateSearch: (search: Record<string, unknown>): ListStartSearch =>
    isListKind(search.kind) ? { kind: search.kind } : {},
  component: ListStartPage,
});
